import type { Step } from "react-joyride";

export const qcFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມສ້າງມາດຕະຖານ QC! ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຟອມນີ້ໃນບົດສອນສັ້ນໆນີ້. ມາດຕະຖານ QC ຈະຊ່ວຍທ່ານກຳນົດລະບຽບການກວດຄຸນນະພາບສຳລັບການດຳເນີນງານ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="form-name"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຊື່ມາດຕະຖານ QC. ກະລຸນາໃສ່ຊື່ທີ່ຊັດເຈນແລະອະທິບາຍວ່າມາດຕະຖານ QC ນີ້ສຳລັບຫຍັງ. ຕົວຢ່າງ: 'ມາດຕະຖານ QC ການຜະລິດ', 'ມາດຕະຖານ QC ການບຳລຸງຮັກສາ'. ຊ່ອງນີ້ຈຳເປັນຕ້ອງປ້ອນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-description"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຄຳອະທິບາຍ. ທ່ານສາມາດໃສ່ຄຳອະທິບາຍເພີ່ມເຕີມກ່ຽວກັບມາດຕະຖານ QC ນີ້ (ບໍ່ບັງຄັບ). ຄຳອະທິບາຍຈະຊ່ວຍໃຫ້ຜູ້ໃຊ້ອື່ນເຂົ້າໃຈຈຸດປະສົງຂອງມາດຕະຖານ QC ນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-work-type"]',
    content:
      "ນີ້ແມ່ນການເລືອກງານ / ຂັ້ນຕອນ. ທ່ານຕ້ອງເລືອກປະເພດງານທີ່ມາດຕະຖານ QC ນີ້ຈະນຳໃຊ້. ຕົວຢ່າງ: ການຜະລິດ, ການບຳລຸງຮັກສາ, ການບໍລິການ. ຊ່ອງນີ້ຈຳເປັນຕ້ອງເລືອກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-work-stage"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຂັ້ນຕອນການດຳເນີນງານ. ທ່ານສາມາດໃສ່ຂັ້ນຕອນທີ່ມາດຕະຖານ QC ນີ້ຈະນຳໃຊ້ (ບໍ່ບັງຄັບ). ຕົວຢ່າງ: 'ກ່ອນແພັກ', 'ຫຼັງຜະລິດ', 'ກ່ອນສົ່ງມອບ'. ຖ້າບໍ່ຈຳເປັນສາມາດຂ້າມໄດ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-department"]',
    content:
      "ນີ້ແມ່ນການເລືອກພະແນກ. ທ່ານສາມາດເລືອກພະແນກທີ່ມາດຕະຖານ QC ນີ້ຈະນຳໃຊ້ (ບໍ່ບັງຄັບ). ຖ້າບໍ່ເລືອກ, ມາດຕະຖານ QC ນີ້ຈະສາມາດນຳໃຊ້ໄດ້ກັບທຸກພະແນກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-inspector"]',
    content:
      "ນີ້ແມ່ນການເລືອກຜູ້ກວດສອບ. ທ່ານສາມາດເລືອກຕຳແໜ່ງຜູ້ກວດສອບທີ່ຈະມີສິດໃຊ້ມາດຕະຖານ QC ນີ້ (ບໍ່ບັງຄັບ). ຖ້າບໍ່ເລືອກ, ທຸກຕຳແໜ່ງຈະສາມາດໃຊ້ໄດ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-items"]',
    content:
      "ນີ້ແມ່ນພາກລາຍການກວດສອບ. ທ່ານສາມາດເພີ່ມລາຍການກວດສອບທີ່ຕ້ອງກວດໂດຍກົດປຸ່ມ 'ເພີ່ມລາຍການກວດສອບ'. ສຳລັບແຕ່ລະລາຍການ, ທ່ານສາມາດກຳນົດຊື່, ຄຳອະທິບາຍ, ເກນຜ່ານ, ເກນບໍ່ຜ່ານ, ແລະກຳນົດວ່າຈຳເປັນຕ້ອງກວດຫຼືບໍ່.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-pass-criteria"]',
    content:
      "ນີ້ແມ່ນຊ່ອງເກນຜ່ານ. ທ່ານສາມາດໃສ່ເກນການຜ່ານຂອງມາດຕະຖານ QC ນີ້ (ບໍ່ບັງຄັບ). ຕົວຢ່າງ: 'ຜ່ານທຸກຂໍ້', 'ຜ່ານຢ່າງໜ້ອຍ 80%'. ເກນນີ້ຈະຖືກໃຊ້ໃນການປະເມີນຜົນການກວດ QC.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-fail-criteria"]',
    content:
      "ນີ້ແມ່ນຊ່ອງເກນບໍ່ຜ່ານ. ທ່ານສາມາດໃສ່ເກນການບໍ່ຜ່ານຂອງມາດຕະຖານ QC ນີ້ (ບໍ່ບັງຄັບ). ຕົວຢ່າງ: 'ມີຂໍ້ໃດຂໍ້ໜຶ່ງບໍ່ຜ່ານ', 'ຜ່ານໜ້ອຍກວ່າ 60%'. ເກນນີ້ຈະຖືກໃຊ້ໃນການປະເມີນຜົນການກວດ QC.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-action-on-fail"]',
    content:
      "ນີ້ແມ່ນຊ່ອງແນວທາງເມື່ອບໍ່ຜ່ານ. ທ່ານສາມາດໃສ່ສິ່ງທີ່ຄວນທຳເມື່ອຜົນການກວດ QC ບໍ່ຜ່ານ (ບໍ່ບັງຄັບ). ຕົວຢ່າງ: 'ແກ້ໄຂທັນທີ', 'ສົ່ງໃຫ້ຫົວໜ້າພະແນກ'. ຂໍ້ມູນນີ້ຈະຊ່ວຍໃຫ້ຜູ້ກວດຮູ້ວ່າຄວນຈັດການແນວໃດເມື່ອບໍ່ຜ່ານ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-notify-position"]',
    content:
      "ນີ້ແມ່ນການເລືອກຕຳແໜ່ງທີ່ຕ້ອງຮັບແຈ້ງເມື່ອບໍ່ຜ່ານ. ທ່ານສາມາດເລືອກຕຳແໜ່ງທີ່ຕ້ອງຮັບແຈ້ງເມື່ອຜົນການກວດ QC ບໍ່ຜ່ານ (ບໍ່ບັງຄັບ). ຕົວຢ່າງ: ຫົວໜ້າພະແນກ, ຜູ້ຈັດການຄຸນນະພາບ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-require-photo"]',
    content:
      "ນີ້ແມ່ນ checkbox ຕ້ອງມີຮູບພາບ. ຖ້າກົດ checkbox ນີ້, ເມື່ອບັນທຶກຜົນການກວດ QC, ຜູ້ກວດຈະຕ້ອງອັບໂຫຼດຮູບພາບ. ການຕັ້ງຄ່ານີ້ຈະຊ່ວຍໃຫ້ມີຫຼັກຖານສະແດງຜົນການກວດ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-require-notes"]',
    content:
      "ນີ້ແມ່ນ checkbox ຕ້ອງໃສ່ໝາຍເຫດເມື່ອບໍ່ຜ່ານ. ຖ້າກົດ checkbox ນີ້, ເມື່ອບັນທຶກຜົນການກວດ QC ແລະບໍ່ຜ່ານ, ຜູ້ກວດຈະຕ້ອງໃສ່ໝາຍເຫດອະທິບາຍ. ການຕັ້ງຄ່ານີ້ຈະຊ່ວຍໃຫ້ມີຂໍ້ມູນເພີ່ມເຕີມເມື່ອບໍ່ຜ່ານ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-status"]',
    content:
      "ນີ້ແມ່ນການເລືອກສະຖານະ. ທ່ານຕ້ອງເລືອກສະຖານະຂອງມາດຕະຖານ QC: ໃຊ້ງານ (ສາມາດນຳໃຊ້ໄດ້ທັນທີ), ປັບປຸງ (ເກັບໄວ້ເປັນຮ່າງ, ຍັງບໍ່ພ້ອມ), ຫຼື ເລີກໃຊ້ (ບໍ່ໃຊ້ງານແລ້ວ).",
    placement: "top",
  },
  {
    target: '[data-tourid="form-checklist"]',
    content:
      "ນີ້ແມ່ນການຜູກມັດ (Mapping) ກັບ Checklist. ທ່ານສາມາດເລືອກ Checklist ທີ່ຕ້ອງການຜູກມັດກັບມາດຕະຖານ QC ນີ້ (ບໍ່ບັງຄັບ). ການຜູກມັດນີ້ຈະຊ່ວຍໃຫ້ສາມາດຈັດການການກວດສອບກັບ Checklist ໄດ້ຢ່າງສະດວກ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-kpi"]',
    content:
      "ນີ້ແມ່ນການຜູກມັດ (Mapping) ກັບ KPI. ທ່ານສາມາດເລືອກ KPI ທີ່ຕ້ອງການຜູກມັດກັບມາດຕະຖານ QC ນີ້ (ບໍ່ບັງຄັບ). ການຜູກມັດນີ້ຈະຊ່ວຍໃຫ້ຜົນການກວດ QC ຖືກນຳໄປໃຊ້ໃນການຄິດໄລ່ KPI ອັດຕະໂນມັດ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-save-draft"]',
    content:
      "ນີ້ແມ່ນປຸ່ມບັນທຶກເປັນຮ່າງ. ຖ້າທ່ານຍັງບໍ່ພ້ອມທີ່ຈະໃຊ້ງານມາດຕະຖານ QC ນີ້, ທ່ານສາມາດກົດປຸ່ມນີ້ເພື່ອບັນທຶກມາດຕະຖານ QC ເປັນຮ່າງໄວ້ກ່ອນ. ມາດຕະຖານ QC ທີ່ບັນທຶກເປັນຮ່າງຈະບໍ່ຖືກນຳໃຊ້ແຕ່ທ່ານສາມາດມາແກ້ໄຂແລ້ວບັນທຶກອີກຄັ້ງໄດ້ເມື່ອພ້ອມ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-submit"]',
    content:
      "ຫຼັງຈາກຕື່ມຂໍ້ມູນຄົບຖ້ວນແລ້ວ, ກົດປຸ່ມ 'ບັນທຶກແລະເຜີຍແຜ່' (ສຳລັບການສ້າງໃໝ່) ຫຼື 'ບັນທຶກ' (ສຳລັບການແກ້ໄຂ) ເພື່ອບັນທຶກມາດຕະຖານ QC ຂອງທ່ານ. ມາດຕະຖານ QC ທີ່ບັນທຶກແລ້ວຈະສາມາດໃຊ້ງານໄດ້ທັນທີ.",
    placement: "top",
  },
];
